import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export const useGeneralCommentsAddMutation = (generalCommentComponentType: ComponentType) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { file?: File, generalCommentText: string, generalCommentComponentSid: string}) =>
            hcaClientFactory.generalCommentsApi.addGeneralComments(payload.file, payload.generalCommentText, payload.generalCommentComponentSid, generalCommentComponentType),
        onSuccess: async (_response, payload) => {
            if (generalCommentComponentType === ComponentType.Transformer) {
                await queryClient.resetQueries({ queryKey: ['transformers', payload.generalCommentComponentSid, 'generalComments'] })
            } else if (generalCommentComponentType === ComponentType.Generator) {
                await queryClient.resetQueries({ queryKey: ['generators', payload.generalCommentComponentSid, 'generalComments'] })
            }
        },
    })
}
